/**
 * @generated SignedSource<<39692125f8f0c018630a38181034a6f7>>
 * @relayHash 76ee6f0db33d8849d67b816c512a322d
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 76ee6f0db33d8849d67b816c512a322d

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VerifyMedicationStatus = "NONE" | "NOT_ENQUIRED" | "SOME";
export type De_verifyMedicationInput = {
  appointmentId: string;
  patientId: string;
  verifyMedicationStatus: VerifyMedicationStatus;
};
export type deVerifyMedicationMutation$variables = {
  input: De_verifyMedicationInput;
};
export type deVerifyMedicationMutation$data = {
  readonly de_verifyMedication: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly medicationVerification: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"MedicationVerificationFragment">;
    } | null;
  };
};
export type deVerifyMedicationMutation = {
  response: deVerifyMedicationMutation$data;
  variables: deVerifyMedicationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deVerifyMedicationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_verifyMedicationPayload",
        "kind": "LinkedField",
        "name": "de_verifyMedication",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MedicationVerification",
            "kind": "LinkedField",
            "name": "medicationVerification",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MedicationVerificationFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deVerifyMedicationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_verifyMedicationPayload",
        "kind": "LinkedField",
        "name": "de_verifyMedication",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MedicationVerification",
            "kind": "LinkedField",
            "name": "medicationVerification",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appointmentId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "patientId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "verifiedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "verifiedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "verifyMedicationStatus",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "76ee6f0db33d8849d67b816c512a322d",
    "metadata": {},
    "name": "deVerifyMedicationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "8b619377baf306a0389f95023674f101";

export default node;
